<template>
  <div>
    <!-- 商品列表 -->
    <div v-if="cartModel.goodsCount" :class="_.bd">
      <div
        v-for="group in cartModel.groupedValidGoodsData"
        :key="group.martId"
        :class="_.group"
      >
        <div
          :class="[_.title, _._hairlineBottom]"
          @click="cartModel.navigateToMartPage(group.martId)"
        >
          <CartCheckbox
            :checked="cartModel.isSelectMart[group.martId]"
            @click.stop="cartModel.selectMart(group)"
          />
          <img :src="require('./images/店铺.png')" :class="_.icon" />
          <div :class="[_.name, _._ellipsis]">{{ group.martName }}</div>
          <x-icon name="arrow" :class="_.arrow" />
        </div>
        <div :class="_.list">
          <CartGoods
            v-for="item in group.goodsData"
            :key="item.skuId"
            :item="item"
          />
        </div>
      </div>

      <div v-if="cartModel.invalidGoodsCount" :class="_.group">
        <div :class="[_.title, _._hairlineBottom]">
          <CartCheckbox
            v-if="cartModel.isEditMode"
            :checked="cartModel.isSelectInvalid"
            @click="cartModel.selectInvalid()"
          />
          <div :class="_.name">失效商品{{ cartModel.invalidGoodsCount }}件</div>
          <div :class="_.actions">
            <div
              v-track="{
                name: '移到收藏夹',
                id: 'ae151806-7eb8-4bf0-8fde-34ef818d0c56',
              }"
              :class="_.item"
              @click="cartModel.moveInvalidToFavorite()"
            >
              移入收藏夹
            </div>
            <div
              v-track="{
                name: '清空失效商品',
                id: '8cc54920-b23a-44c1-9cf3-e9e790d6c6df',
              }"
              :class="_.item"
              @click="cartModel.deleteInvalid()"
            >
              清空失效商品
            </div>
          </div>
        </div>
        <div :class="_.list">
          <CartGoods
            v-for="item in cartModel.invalidGoodsData"
            :key="item.skuId"
            :item="item"
          />
        </div>
      </div>
    </div>
    <x-empty
      v-else
      :class="_.empty"
      type="购物车"
      message="这么多实惠好物，不加入购物车吗？"
      :confirm-text="!$globalModel.state.isPure ? '去逛逛' : ''"
      :confirm-track="{
        name: '去逛逛',
        id: '32e70944-080e-4126-8285-098944f56dbb',
      }"
      @confirm="handleBackHomeClick"
    />

    <!-- 推荐 -->
    <x-goods-recommend
      v-if="
        !$globalModel.state.isPure &&
        $globalModel.state.channelIsShowDcbResource
      "
      resource-position-id="8aaa8ac37b113694017b114225520015"
    />
  </div>
</template>

<script>
  import CartCheckbox from './checkbox.vue'
  import CartGoods from './goods.vue'
  import { cartModelProvider } from '../model'
  import { defineClassComponent } from '@/hooks'
  import { redirectTo } from '@/router'

  export default defineClassComponent(
    {
      components: {
        CartCheckbox,
        CartGoods,
      },
    },
    () =>
      class {
        cartModel = cartModelProvider.inject()

        handleBackHomeClick = () => {
          redirectTo('HomeIndex')
        }
      },
  )
</script>

<style lang="scss" module>
  .bd {
    padding: 12px;

    .group {
      padding: 12px;
      border-radius: 8px;
      background: #ffffff;

      .title {
        display: flex;
        align-items: center;
        padding-bottom: 12px;

        .icon {
          margin-left: 12px;
          width: 16px;
          height: 16px;
        }

        .name {
          font-size: 14px;
          color: #222222;

          &:not(:first-child) {
            margin-left: 8px;
          }
        }

        .arrow {
          margin-left: 4px;
          flex-shrink: 0;
          font-size: 14px;
          color: #bebebe;
        }

        .actions {
          flex-grow: 1;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .item {
            font-size: 12px;
            color: #ff111c;

            &:active {
              opacity: 0.8;
            }

            + .item {
              margin-left: 16px;
            }
          }
        }
      }

      .list {
        padding-top: 12px;
      }

      + .group {
        margin-top: 12px;
      }
    }
  }

  .empty {
    padding: 20px 0;
  }
</style>
